module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/congress/shared/layout/congress-warn-modal/congress-warn-modal.component.css
// module id = ./src/congress/shared/layout/congress-warn-modal/congress-warn-modal.component.css
// module chunks = main